
import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Company Info */}
        <div className="footer-section">
          <h3>About Neha Packers & Movers</h3>
          <p>
            <strong>Neha Packers & Movers:</strong>  Neha  Packers & Movers is committed to delivering top-notch moving services with a focus on safety, reliability, and customer satisfaction. With years of expertise, we make moving stress-free for our clients.
          </p>
          <p><strong>Neha Packers & Movers <span className="bi bi-truck"></span> : </strong>We Provide Travel facility, Your Product will be delivered by us.</p>
        </div>


        {/* Contact Info */}
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>
            <strong>Email:</strong> nehapackersmovers@gmail.com
          </p>
          <p>
            <strong>Phone:</strong> +91 9625581855
          </p>
          <p>
            <strong>Local & Domestic Office:</strong> Gaya, Patna, Ranchi, Delhi
          </p>
          <div className="social-icons">
            <a href="/" target="_blank" rel="noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="/" target="_blank" rel="noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="/" target="_blank" rel="noreferrer">
              <i className="fab fa-linkedin"></i>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About Us</Link></li>
          <li><Link to="/services">Our Services</Link></li>
          <li><Link to="/gallery">Gallery</Link></li>
          <li><Link to="/quote">Get a Quote</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* map */}
        {/* <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d320.16718004914753!2d84.99464461618628!3d24.785927479144338!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f32b341b8820f9%3A0x44cf9fadc2a964ba!2zR2V3YWwgQmlnaGEgTW9yZSDgpJfgpYfgpLXgpLIg4KSs4KWA4KSY4KS-IOCkruCli-CkoeCkvA!5e0!3m2!1sen!2sin!4v1736514974112!5m2!1sen!2sin" width="1200" height="300" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>         */}


      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Neha Packers & Movers. All rights reserved. Design & Developed by <a target="-blank" href="https://www.mountgit.com/">MountGit</a> </p>
      </div>
    </footer>
  );
}